/**
 * Attention glow for the floating compare-cart FAB. The cart only renders once
 * it holds something, so the glow is always on while it is visible: a pulsing
 * halo in the FAB's own colour plus a gentle wiggle of the cart icon, so the
 * button stands out from the identical-looking AI and Share FABs around it.
 *
 * Spread into the Fab's `sx` alongside its positioning.
 */
export const CART_FAB_GLOW_SX = {
  '@keyframes cartFabGlow': {
    '0%': { boxShadow: '0 0 0 0 rgba(224, 142, 74, 0.75), 0 0 12px 2px rgba(255, 183, 77, 0.55)' },
    '70%': { boxShadow: '0 0 0 16px rgba(224, 142, 74, 0), 0 0 24px 8px rgba(255, 183, 77, 0.85)' },
    '100%': { boxShadow: '0 0 0 0 rgba(224, 142, 74, 0), 0 0 12px 2px rgba(255, 183, 77, 0.55)' },
  },
  '@keyframes cartIconWiggle': {
    '0%, 80%, 100%': { transform: 'rotate(0deg)' },
    '84%': { transform: 'rotate(-14deg)' },
    '88%': { transform: 'rotate(12deg)' },
    '92%': { transform: 'rotate(-8deg)' },
    '96%': { transform: 'rotate(4deg)' },
  },
  animation: 'cartFabGlow 1.6s ease-out infinite',
  '& .MuiSvgIcon-root': { animation: 'cartIconWiggle 2.4s ease-in-out infinite' },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    boxShadow: '0 0 16px 4px rgba(255, 183, 77, 0.8)',
    '& .MuiSvgIcon-root': { animation: 'none' },
  },
};
